import {AnyAction} from 'redux';
import {RECORD_ENERGY_GENERATED, RESET_ENERGY_GENERATED} from '../action';

export function recordEnergyGenerated(energy: number) : AnyAction
{
    return {type: RECORD_ENERGY_GENERATED, payload: {energy}};
}


export function resetEnergyGenerated() : AnyAction
{
    return {type: RESET_ENERGY_GENERATED, payload: {}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/mini-game/energyGenerated.ts